import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { PDFDocument } from 'pdf-lib';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-loans-contract-details',
  templateUrl: './loans-contract-details.component.html',
  styleUrls: ['./loans-contract-details.component.scss']
})
export class LoansContractDetailsComponent implements OnInit {

  pdfView: Uint8Array;
  pdfSrc = 'assets/loan-contract.pdf';
  pdfBytes: Uint8Array;
  fileName: string;
  fileUrl: any;
  contractId: any;
  role: any;
  amortizationData ={
    list: "",
    contractId: 0
  }
  cierreData:any;

  language = "es";
  isLoan = false;

  loanType: String;

  public contractForm: FormGroup;
  automaticDebitStatus = false;
  accountTypeStatus: any;

  contractDetails: any;
  notes: any;

  publicFormData = false;

  constructor(private router: Router, private sanitizer: DomSanitizer, private route: ActivatedRoute, private authService: AuthenticationService, private _fb: FormBuilder) { }

  ngOnInit(): void {
    this.setUpPage();
  }
  updateLanguage(event:any){  
    let val = event.target.value;
    console.log(val);
    if(this.isLoan){
      if(val =="en"){
        this.pdfSrc = 'assets/loan-contract-en.pdf';
        this.contractRefresh();
      }else{
        this.pdfSrc = 'assets/loan-contract.pdf';
        this.contractRefresh();
      }
    }else{
      if(val =="en"){

        if(this.loanType == "Prestamo de Enseres"){
          this.pdfSrc = 'assets/loan-contract-enseres-en.pdf';
        }
        if(this.loanType == "Credit Loan"){
          this.pdfSrc = 'assets/loan-contract-credit-loan-en.pdf';
        }
        
        this.contractRefresh();
      }else{
        this.pdfSrc = 'assets/loan-contract-enseres.pdf';
        this.contractRefresh();
      }
    }
    
  }

  setUpPage(){
    this.role = this.authService.getUserRole();
    this.contractId = this.route.snapshot.paramMap.get("id");
    this.getLoanContract(this.contractId);
    this.setUpForm();
  }

  setUpForm(){
    this.contractForm = this._fb.group({
      loanApproval: [null,[Validators.required]],
      loanApprovalNotes: [null],
      textMsgNotification: [null,[Validators.required]],
      automaticDebit: [null,[Validators.required]],
      bankInstName: [""],
      showAnualInterest: [null],
      bankInstRoutingNum: [""],
      accountNumber: [""],
      accountType: [""],
      cardType: [""],
      cardNumber: [""],
      cardExp: [""],
     })
  }

  updateAutomaticDebit(){
    let autoDebit = this.contractForm.controls['automaticDebit'].value;
    this.automaticDebitStatus = autoDebit == "si" ? true : false;
  }

  updateAccountType(){
    this.accountTypeStatus = this.contractForm.controls['accountType'].value;
    if(this.accountTypeStatus == 'cheque' || this.accountTypeStatus == 'ahorro'){
      this.contractForm.patchValue({
        cardNumber: '',
        cardType: '',
        cardExp: ''
      });
    }
    else if(this.accountTypeStatus == 'credito') {
      this.contractForm.patchValue({
        accountNumber: '',
        bankInstRoutingNum: '',
      });
    }
  }

  contractRefresh(){
    let showAnnualPercent = this.contractForm.controls['showAnualInterest'].value;
    // console.log(showAnnualPercent);

    
    let contractDetails2 = structuredClone(this.contractDetails);
    if(showAnnualPercent == "no"){
      contractDetails2.tasaInteresAnual = ""
    }

    this.contractDetails = {
      ...contractDetails2,
      ...this.contractForm.getRawValue()
    } 

    this.cierreData = {
      ...this.cierreData,
      ...this.contractForm.getRawValue()
    }

    let data = this.contractForm.getRawValue();

    if(data.loanApproval == "si"){
      this.contractDetails.loanApprovalNotesApproved = data.loanApprovalNotes;
    } else{
      this.contractDetails.loanApprovalNotesDenied = data.loanApprovalNotes;
    }
    
    // let data = {
    //   id:  this.contractDetails.id,
    //   data: this.contractForm.getRawValue()
    // }
    // this.authService.saveFinanceData(data);
    // console.log(this.contractDetails);
    // if(this.contractDetails.idProducer){
    console.log(this.publicFormData);
      if(!this.publicFormData){
        this.createPDFContract(this.contractDetails);
      }
      
    // }
    
    this.updateData(this.contractForm.getRawValue());
  }

  getLoanContract(contarctId:Number){
    this.authService.getLoanContract(contarctId).then((res:any)=>{
      console.log(res);
      this.loanType = res.loanType;
      if(res.loanType != "Prestamo Personal"){
        if(this.loanType == "Prestamo de Enseres"){
          this.pdfSrc = 'assets/loan-contract-enseres.pdf';
        }
        if(this.loanType == "Credit Loan"){
          this.pdfSrc = 'assets/loan-contract-credit-loan.pdf';
        }
        this.isLoan = false;
      }else{
        this.isLoan = true;
      }
        console.log(res);
        console.log( this.pdfSrc);
         //Parse Data
        let keys = Object.keys(res);
        keys.forEach((key, index) => {
          if(typeof res[key] != 'string') return
          if(this.isJsonString(res[key])){
            // console.log(data[key]);
            res[key] = JSON.parse(res[key]);
          }
        });
        this.notes = res.notes;
        this.contractDetails = res;
        this.cierreData = res;
        // this.amortizationData.list = res.amortization;
        if(res.isApproved == 1){
          this.contractForm.patchValue({
            loanApproval: "si"
          })
        } 
        if(res.isApproved == 0){
          this.contractForm.patchValue({
            loanApproval: "no"
          })
        } 
        if(res.txtMsgs == 0){
          this.contractForm.patchValue({
            textMsgNotification: "no"
          })
        } 
        if(res.txtMsgs == 1){
          this.contractForm.patchValue({
            textMsgNotification: "si"
          })
        } 
        if(res.otherNotes){
          this.contractForm.patchValue({
            loanApprovalNotes: res.otherNotes
          })
        }
        // this.amortizationData.contractId = this.contractId;
        // this.createPDFContract(res);
        console.log(res);
        // res.bienesJson = JSON.stringify(res.bienesJson);
        let isValidJson = false;
        // try {
        //   JSON.parse(res.bienesJson);
        //   isValidJson = true;
        // } catch (e) {
        //   console.error("Invalid JSON in res.bienesJson", e);
        // }
        // if(res.bienesJson.includes("[") || res.bienesJson == "null"){
        //   isValidJson = true;
        // }

        if(res.idProducer == null ){
          this.publicFormData = true;
        }
        this.contractRefresh()
    })
    // this.authService.getLoanContracts().then((res:any)=>{
    //     let data = res.find((x:any) => x.id == contarctId)
    //     //Parse Data
    //     let keys = Object.keys(data);
    //     keys.forEach((key, index) => {
    //       if(typeof data[key] != 'string') return
    //       if(this.isJsonString(data[key])){
    //         // console.log(data[key]);
    //         data[key] = JSON.parse(data[key]);
    //       }
    //     });
    //     console.log(data);
    //     this.contractDetails = data;
    //     this.amortizationData.list = data.amortization;
    //     this.amortizationData.contractId = this.contractId;
    //     this.createPDFContract(data);
    //   })
  }

  async createPDFContract(data:any){
    let datePipe = new DatePipe('en-US');
    let existingPDFBytes = await fetch(this.pdfSrc).then(res => res.arrayBuffer());

    const pdfDoc = await PDFDocument.load(existingPDFBytes);

    const form = pdfDoc.getForm();
    const fields = form.getFields();
    
    let colateral = ['cd','auto','certificados','bienes','propiedades','otros'];

    fields.forEach(field => {

      const name = field.getName();

      if(name.includes(".")){
        let objectKeys = name.split(".");
        let val = data;
        for(let key of objectKeys){
          var lastChar = key.charAt(key.length - 1);
          if(parseInt(lastChar)){
            let pos = parseInt(lastChar)-1;
            key = key.slice(0, -1)  
            console.log(val);    
            if(typeof val == 'string' && this.isJsonString(val)){ 
              val = JSON.parse(val);
              if(val){
                val = val[key][pos] || '';
              }
            }
            // console.log(key);
            // console.log(pos);
            // console.log(val);
            

            
          }else{
            
            if(key == 'physicalAddress'){
              let address = val.physicalAddress1;
              if(val.physicalAddress2){
                address += ", " +val.physicalAddress2;
              }
              val = address;
              
            }else if(key == 'postalAddress'){
              let address = val.postalAddress1;
              if(val.postalAddress2){
                address += ", " +val.postalAddress2;
              }
              val = address;
            }else if(key == 'isCodeudorNo'){
              val = val['isCodeudor'] == 'no' ? "X" : "";
            }else if(key == 'isCodeudorSi'){
              val = val['isCodeudor'] == 'si' ? "X" : "";
            }else if(colateral.includes(key)){
              if(data.colaterals.colaterals.includes(key)){
                val = 'X';
              } else {
                val = '';
              }
            }
            else if(key == 'birthDate'){
              if(val[key]){
                let date:any = new Date(val[key]);
                date.setDate(date.getDate() + 1); // fix off 1 day error ¿Why?
                
                val =  datePipe.transform(date, 'MM-dd-yyyy');
              }else{
                val = ''
              }
              
              
            }
            else{
              // console.log(key);
              val = val[key] || '';
            }

            
          }
          if(val){
            form.getTextField(name).setText(val.toString());
          } else{
            form.getTextField(name).setText('');
          }
          
          
        }
        // console.log(val);
      }else{
        
        
        // console.log(name);
        if(name == 'textMsgNotificationSi'){
          if(data['textMsgNotification']== 'si'){
            form.getTextField(name).setText('X');
          }
          
        }else if(name == 'textMsgNotificationNo'){
          if(data['textMsgNotification']== 'no'){
            form.getTextField(name).setText('X');
          }
        }else if(name == 'loanApprovalSi'){
          if(data['loanApproval']== 'si'){
            
            form.getTextField(name).setText('X');
            form.getTextField('loanApprovalNotesApproved').setText(data['otherNotes'] || "");
          }
        }else if(name == 'loanApprovalNo'){
          if(data['loanApproval']== 'no'){
            form.getTextField(name).setText('X');
            form.getTextField('loanApprovalNotesDenied').setText(data['otherNotes'] || "");
          }
        }
        else if(name == 'accountTypeCheque'){
          if(data['accountType']== 'cheque'){
            form.getTextField(name).setText('X');
          }
        }
        else if(name == 'accountTypeAhorro'){
          if(data['accountType']== 'ahorro'){
            form.getTextField(name).setText('X');
          }
        }else if(name == 'garantia'){
          // console.log('garantia');
          let selection = data[name] ? "Si" : "N/A";
          form.getTextField(name).setText(selection);
        }
        else if(name == 'prestamoPrimerPago'){
          // console.log(data.amortization);
          let amortization = data.amortization;
          let firstPay = amortization[0].thisDate;
          firstPay = datePipe.transform(firstPay, 'MM-dd-yyyy');
          form.getTextField(name).setText(firstPay);
        }
        else if(name == 'prestamoUltimoPago'){
          // console.log(data.amortization);
          let amortization = data.amortization;
          let lastPay = amortization[amortization.length-1].thisDate;
          lastPay = datePipe.transform(lastPay, 'MM-dd-yyyy');
          form.getTextField(name).setText(lastPay);
        }
        else if(name == 'prestamoInicio' || name == 'prestamoCulminacion'){
          // console.log('date');
          let date:any = datePipe.transform(data[name], 'MM-dd-yyyy');
          form.getTextField(name).setText(date);
        }else if(data[name] == null) return;
        else{
          form.getTextField(name).setText(data[name].toString());
        }
        
        
      }
      
      

    })
    this.fileName = `contrato-Central-Credit-${data.insCompany}-${data.insName}-${data.qDateEffective}`;

    form.flatten();
    
    this.pdfBytes = await pdfDoc.save()
    
    const blob = new Blob([this.pdfBytes], { type: 'application/pdf' });

    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.pdfView = new Uint8Array(fileReader.result as ArrayBuffer);
    };
    fileReader.readAsArrayBuffer(blob);  

    
  }

  


  updateNotes(){
    this.contractDetails.notes = this.notes;
    let contract = {
      ...this.contractDetails
    };
    //stringify
    let keys = Object.keys(contract);
    keys.forEach((key, index) => {
      if(typeof contract[key] == 'object'){
        let string =  JSON.stringify(contract[key]);
        if(string[0] == "{" || string[0] == "["){
          contract[key] = JSON.stringify(contract[key]);
        }
      }
    });
    // console.log(contract);
    this.authService.updateLoanContract(contract).then(res=>{
      // console.log(res);
    }, err=>{
      console.log(err);
    })
  }

  updateData(data:any){
    // console.log(data);
    
    if(data.loanApproval == 'si'){
      this.contractDetails.isApproved = 1;
      this.contractDetails.active = 1;
    }

    if(data.loanApproval == 'no'){
      this.contractDetails.isApproved = 0;
    }

    if(data.textMsgNotification == 'si'){
      this.contractDetails.txtMsgs = 1;
    }

    if(data.textMsgNotification == 'no'){
      this.contractDetails.txtMsgs = 0;
    }
    let contract = {
      ...this.contractDetails
    };
    //stringify
    let keys = Object.keys(contract);
    keys.forEach((key, index) => {
      if(typeof contract[key] == 'object'){
        let string =  JSON.stringify(contract[key]);
        if(string[0] == "{" || string[0] == "["){
          contract[key] = JSON.stringify(contract[key]);
        }
      }
    });

    contract.otherNotes = data.loanApprovalNotes;
    // console.log(contract);
    this.authService.updateLoanContract(contract).then(res=>{
      // console.log(res);
      
    }, err=>{
      console.log(err);
    })
  }



  isJsonString(str:any) {

    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }

  editContract() {
    let navigationExtras: NavigationExtras = {
      state: {
        quoteData: this.contractDetails
      }
    };
    this.router.navigate(["loans/quotation"], navigationExtras);
  }

}
